const templateUrl = "visualizer/js/modules/core/archivePill/archivePill.tpl.html";

const ArchivePillComponent = {
  templateUrl,
};

export default ArchivePillComponent;
